var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("FormSubmitPopup", {
        ref: "form",
        attrs: {
          title: _vm.$t("buyLabel"),
          rightMethod: _vm.onSubmitted,
          rightButtonText: _vm.$t("labelSubmit"),
          hasAlert: "",
          large: "",
          rightButtonDisabled: _vm.orderLens > 20 || _vm.isBatchLoading,
          disabledClose: _vm.isBatchLoading || _vm.isLoading
        },
        on: {
          popupClose: function($event) {
            return _vm.$emit("input", false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-layout",
                  {
                    staticClass: "subheading",
                    attrs: { "justify-space-between": "" }
                  },
                  [
                    _c("v-flex", { attrs: { md8: "" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("purchaseNumLabel(s)", {
                              length: _vm.orderLens
                            })
                          ) +
                          "\n          "
                      ),
                      _c("b", [_vm._v(_vm._s(_vm.$t("note")) + ": ")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("USPSLabelCannotBeCanceled")) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md2: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: _vm.$t("addSearchKeywords"),
                            hint: _vm.$t("addSpaceDelimitedKeywords")
                          },
                          model: {
                            value: _vm.keywords,
                            callback: function($$v) {
                              _vm.keywords =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "keywords"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-data-table", {
                  staticClass: "elevation-2 myDense",
                  attrs: {
                    headers: _vm.headers,
                    items: Object.values(_vm.orders),
                    "item-key": "orderId",
                    "hide-actions": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("v-layout", [
                                _vm._v(
                                  " ID: " +
                                    _vm._s(
                                      props.item.orderName || props.item.orderId
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(props.item.items, function(item, index) {
                                return _c(
                                  "v-layout",
                                  { key: item.orderItemId + index },
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _c("ProductWidget", {
                                          attrs: {
                                            name: item.productName,
                                            sku: [item.sku]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-sm-left",
                                                attrs: { md6: "" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color:
                                                        item.quantityPurchased >
                                                        1
                                                          ? "white"
                                                          : "black",
                                                      backgroundColor:
                                                        item.quantityPurchased >
                                                        1
                                                          ? "red"
                                                          : ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("purchased")
                                                      ) +
                                                        ": " +
                                                        _vm._s(
                                                          item.quantityPurchased
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "text-sm-left",
                                                attrs: { md6: "" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("shipped")) +
                                                    ": " +
                                                    _vm._s(item.quantityShipped)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { "align-baseline": "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { md5: "" } },
                                              [
                                                _c(
                                                  "v-form",
                                                  {
                                                    ref:
                                                      "form-" +
                                                      props.item.orderId +
                                                      "-0-" +
                                                      item.orderItemId,
                                                    refInFor: true,
                                                    attrs: {
                                                      "lazy-validation": ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "to ship"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "to-ship"
                                                          ),
                                                          _vm.fieldIsOverZero(
                                                            "to-ship"
                                                          ),
                                                          _vm.fieldIsInteger(
                                                            "to-ship"
                                                          ),
                                                          function(v) {
                                                            return (
                                                              item.quantityShipped +
                                                                v <=
                                                                item.quantityPurchased ||
                                                              _vm.$t(
                                                                "toShipShippedExceedsPurchasedQty"
                                                              )
                                                            )
                                                          }
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.toShip[
                                                            item.orderItemId
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item.toShip,
                                                            item.orderItemId,
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.toShip[item.orderItemId]"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { "align-baseline": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { md5: "" } },
                                    [
                                      _c("vite-autocomplete", {
                                        attrs: {
                                          "hide-details": "",
                                          items: _vm.fromAddress(props.item),
                                          name: "address-template-name",
                                          "return-object": "",
                                          label: _vm.$t("addressName"),
                                          "item-text": "siteName",
                                          "item-value": "key"
                                        },
                                        on: {
                                          change: function(e) {
                                            return _vm.onSelectAddress(
                                              e,
                                              props.item.orderId
                                            )
                                          }
                                        },
                                        model: {
                                          value: props.item.addressTemplate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              props.item,
                                              "addressTemplate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "props.item.addressTemplate"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.hasHazmatFeatures
                                    ? _c(
                                        "v-flex",
                                        { attrs: { md4: "" } },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "checkbox",
                                            attrs: {
                                              "hide-details": "",
                                              label: _vm.$t("sendHazmat")
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.clearFromTemplate(
                                                  props.item,
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: props.item.isSupportHazmat,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "isSupportHazmat",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.isSupportHazmat"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                [
                                  JSON.stringify(props.item.shipFrom) !== "{}"
                                    ? _c(
                                        "v-flex",
                                        { attrs: { "align-center": "" } },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("shipFrom")) +
                                              ":\n                " +
                                              _vm._s(
                                                props.item.shipFrom.address1 +
                                                  " " +
                                                  (props.item.shipFrom
                                                    .address2 || "") +
                                                  ", " +
                                                  props.item.shipFrom.city +
                                                  ", " +
                                                  props.item.shipFrom.state +
                                                  " " +
                                                  props.item.shipFrom.zipCode
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(tooltip) {
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g({}, tooltip.on),
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticStyle: {
                                                          margin: "0px"
                                                        },
                                                        attrs: {
                                                          color: "primary",
                                                          icon: "",
                                                          small: "",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(e) {
                                                            return _vm.showEditAddressFrom(
                                                              e,
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("edit")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("changeAddress")) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        small: "",
                                        dark: "",
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.applyShipFromToAll(
                                            props.item.shipFrom,
                                            props.item.addressTemplate,
                                            props.item.senderName,
                                            props.item.fromCompanyName
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("applyToAll")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errorMessages[props.item.orderId]
                                ? _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "red--text font-weight-bold text-xs-left"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.errorMessages[
                                                  props.item.orderId
                                                ]
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.warningMessages[props.item.orderId]
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-bold text-xs-left",
                                        staticStyle: {
                                          "background-color": "yellow"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.warningMessages[
                                                props.item.orderId
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.recommendAddress[props.item.orderId]
                                ? _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "font-weight-bold text-xs-left",
                                          staticStyle: {
                                            "background-color": "yellow"
                                          }
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("recommendAddress")
                                              ) + ": "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatRecommendAddress(
                                                  _vm.recommendAddress[
                                                    props.item.orderId
                                                  ]
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            small: "",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.useRecommendAddress(
                                                props.item.orderId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("apply")))]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form-" + props.item.orderId + "-1",
                                  attrs: { "lazy-validation": "" }
                                },
                                [
                                  _c("v-layout", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(props.item.shipServiceLevel)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-layout", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("deliveryBy")) +
                                        " " +
                                        _vm._s(
                                          _vm.toDateString(
                                            props.item.promiseDate
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-layout", [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("recipient")) + ":")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("v-layout", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(props.item.recipientName) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-layout", [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.item.shipAddress1) +
                                        " " +
                                        _vm._s(props.item.shipAddress2) +
                                        " "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.shipCity) +
                                          " - " +
                                          _vm._s(props.item.shipState) +
                                          "\n                " +
                                          _vm._s(props.item.shipPostalCode) +
                                          "\n                "
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticStyle: {
                                                              margin: "0px"
                                                            },
                                                            attrs: {
                                                              color: "primary",
                                                              icon: "",
                                                              small: "",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                e
                                                              ) {
                                                                return _vm.showEditAddressTo(
                                                                  e,
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v("edit")
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("changeAddress")) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.templates,
                                              "return-object": "",
                                              label: _vm.$t("template"),
                                              "persistent-hint": "",
                                              "item-text": "name",
                                              "item-value": "name"
                                            },
                                            on: {
                                              change: function(event) {
                                                return _vm.onSelectTemplate(
                                                  props.item.orderId,
                                                  event
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "append-outer",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            flat: "",
                                                            icon: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.showTemplateDialog(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: "primary"
                                                              }
                                                            },
                                                            [_vm._v("add")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                },
                                                {
                                                  key: "item",
                                                  fn: function(props) {
                                                    return [
                                                      [
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  props.item
                                                                    .name
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: props.item.template,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "template",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.template"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "primary"
                                                            },
                                                            on: {
                                                              click: function(
                                                                e
                                                              ) {
                                                                return _vm.showInstruction(
                                                                  e,
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "shipmentInstruction"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "white-space": "pre-wrap",
                                                "word-break": "break-word",
                                                "max-width": "300px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.instruction ||
                                                    "-" +
                                                      _vm.$t("noInstruction") +
                                                      "-"
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSupportDangerousGoods(props.item)
                                        ? _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                value: !!props.item
                                                  .dangerousGoods,
                                                color: "red",
                                                overlap: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "badge",
                                                    fn: function() {
                                                      return [_c("span")]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { color: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showDangerousGoodsDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("dangerousGoods")
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              props.item.isMPS
                                ? _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { md5: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "hide-details": "",
                                                      label: _vm.$t(
                                                        "PackageTotal"
                                                      ),
                                                      disabled: "",
                                                      value: props.item
                                                        .isOneRate
                                                        ? props.item
                                                            .packageQuantity
                                                        : props.item
                                                            .packageTotal
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              !props.item.isOneRate
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { md5: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "hide-details": "",
                                                          label: _vm.$t(
                                                            "weightTotal"
                                                          ),
                                                          disabled: ""
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .weightLbTotal,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "weightLbTotal",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.weightLbTotal"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              !props.item.isOneRate
                                                ? [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { md7: "" } },
                                                      [
                                                        _c(
                                                          "vite-autocomplete",
                                                          {
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              items:
                                                                props.item
                                                                  .packagingSpecs,
                                                              label: _vm.$t(
                                                                "SelectPackaging"
                                                              ),
                                                              "item-text":
                                                                "packageName",
                                                              "return-object":
                                                                ""
                                                            },
                                                            on: {
                                                              change: function(
                                                                event
                                                              ) {
                                                                return (props.item.weightLb =
                                                                  event.weight)
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .packaging,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "packaging",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.packaging"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    props.item.packaging
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: { md4: "" }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "packageQty"
                                                                ),
                                                                "hide-details":
                                                                  "",
                                                                hint: _vm.$t(
                                                                  "packageQty"
                                                                ),
                                                                rules: [
                                                                  _vm.fieldIsInteger(
                                                                    "packageQty"
                                                                  )
                                                                ]
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.packageQtyChange(
                                                                    props.item
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  props.item
                                                                    .packaging
                                                                    .packageQuantity,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    props.item
                                                                      .packaging,
                                                                    "packageQuantity",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                                expression:
                                                                  "props.item.packaging.packageQuantity"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                : [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { md7: "" } },
                                                      [
                                                        _c(
                                                          "vite-autocomplete",
                                                          {
                                                            attrs: {
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "packagingType"
                                                                )
                                                              ],
                                                              "hide-details":
                                                                "",
                                                              label: _vm.$t(
                                                                "SelectPackaging"
                                                              ),
                                                              items: _vm.getFedexPackagings(
                                                                props.item
                                                              ),
                                                              "item-text":
                                                                "name",
                                                              "item-value": "id"
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .packageType,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "packageType",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.packageType"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { md4: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "packageQty"
                                                            ),
                                                            "hide-details": "",
                                                            hint: _vm.$t(
                                                              "packageQty"
                                                            ),
                                                            rules: [
                                                              _vm.fieldIsInteger(
                                                                "packageQty"
                                                              )
                                                            ],
                                                            readonly: true
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .packageQuantity,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "packageQuantity",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.packageQuantity"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : props.item.isOneRate
                                ? _c(
                                    "v-layout",
                                    { attrs: { "align-center": "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("vite-autocomplete", {
                                            staticClass: "table-item",
                                            attrs: {
                                              rules: [
                                                _vm.fieldIsRequired(
                                                  "packagingType"
                                                )
                                              ],
                                              "hide-details": "",
                                              label: _vm.$t("SelectPackaging"),
                                              items: _vm.getFedexPackagings(
                                                props.item
                                              ),
                                              "item-text": "name",
                                              "item-value": "id"
                                            },
                                            model: {
                                              value: props.item.packageType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "packageType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.packageType"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-form",
                                {
                                  ref: "form-" + props.item.orderId + "-2",
                                  attrs: { "lazy-validation": "" }
                                },
                                [
                                  !props.item.isOneRate
                                    ? [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "weight"
                                                      ),
                                                      _vm.fieldIsOverZero(
                                                        "weight"
                                                      ),
                                                      _vm.isMeasurementMetric
                                                        ? function() {
                                                            return true
                                                          }
                                                        : _vm.fieldIsPkgWeight(
                                                            props.item["isOz"]
                                                          )
                                                    ],
                                                    label: _vm.isMeasurementMetric
                                                      ? _vm.$t("weight") +
                                                        "(kg)"
                                                      : _vm.$t("weight") +
                                                        "(" +
                                                        (props.item["isOz"]
                                                          ? _vm.$t(
                                                              "clickSwitch",
                                                              {
                                                                click: "Oz",
                                                                change: "Lbs"
                                                              }
                                                            )
                                                          : _vm.$t(
                                                              "clickSwitch",
                                                              {
                                                                click: "Lbs",
                                                                change: "Oz"
                                                              }
                                                            )) +
                                                        ")"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.weightLbChange(
                                                        props.item
                                                      )
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            !_vm.isMeasurementMetric
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      cursor:
                                                                        "pointer"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        props.item[
                                                                          "isOz"
                                                                        ] = !props
                                                                          .item[
                                                                          "isOz"
                                                                        ]
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item[
                                                                          "isOz"
                                                                        ]
                                                                          ? "Oz"
                                                                          : "Lbs"
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      props.item["weightLb"],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item,
                                                        "weightLb",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "props.item['weightLb']"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          { attrs: { "align-center": "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { xs4: "" }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "table-item",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("L"),
                                                    suffix: _vm.sizeSuffix,
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "length"
                                                      ),
                                                      _vm.fieldIsOverZero(
                                                        "length"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      props.item.packaging
                                                        .length,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item.packaging,
                                                        "length",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.packaging.length"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "mr-3",
                                                attrs: { xs4: "" }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "table-item",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("W"),
                                                    suffix: _vm.sizeSuffix,
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "width"
                                                      ),
                                                      _vm.fieldIsOverZero(
                                                        "width"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      props.item.packaging
                                                        .width,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item.packaging,
                                                        "width",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.packaging.width"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs4: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "table-item",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("H"),
                                                    suffix: _vm.sizeSuffix,
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "height"
                                                      ),
                                                      _vm.fieldIsOverZero(
                                                        "height"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value:
                                                      props.item.packaging
                                                        .height,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item.packaging,
                                                        "height",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.packaging.height"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs1: "" } },
                                              [
                                                _c("PackagingSelector", {
                                                  attrs: {
                                                    packagings: _vm.packagings
                                                  },
                                                  on: {
                                                    select: function(item) {
                                                      return _vm.onSelectPackaging(
                                                        item,
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              "hide-details": "",
                                              items: _vm.filterShippingServiceByFromState(
                                                _vm.shippingServices,
                                                props.item.shipFrom.state
                                              ),
                                              "item-text": "text",
                                              "menu-props": {
                                                returnValue: "value"
                                              },
                                              rules: [
                                                _vm.fieldIsRequired("service"),
                                                _vm.checkShipForm()
                                              ],
                                              label: _vm.$t("shippingService")
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.shippingServiceOnChange(
                                                  props.item
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function(data) {
                                                    return [
                                                      _vm.isObject(data.item)
                                                        ? [
                                                            _c(
                                                              "v-list-tile-content",
                                                              {
                                                                domProps: {
                                                                  textContent: _vm._s(
                                                                    data.item
                                                                  )
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        : [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          data
                                                                            .item
                                                                            .text
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: props.item.shippingService,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "shippingService",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.shippingService"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-select", {
                                            staticClass: "table-item",
                                            attrs: {
                                              disabled: !_vm.isSupportLabelStockType(
                                                props.item.shippingService
                                              ),
                                              "hide-details": "",
                                              label: _vm.$t("labelStockType"),
                                              items: _vm.labelStockTypes,
                                              "item-text": "text",
                                              "menu-props": {
                                                returnValue: "value"
                                              }
                                            },
                                            model: {
                                              value: props.item.labelStockType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "labelStockType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.labelStockType"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.getCurShippingService(
                                    props.item.shippingService
                                  ).enableReferences
                                    ? [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-select", {
                                                  staticClass: "table-item",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "referenceType"
                                                    ),
                                                    items: _vm.referenceOptions,
                                                    "item-text": "text",
                                                    "menu-props": {
                                                      returnValue: "value"
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      props.item.referenceName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item,
                                                        "referenceName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.referenceName"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-layout",
                                          {
                                            staticStyle: {
                                              "padding-bottom": "10px"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: _vm.$t("reference"),
                                                    disabled: !props.item
                                                      .referenceName,
                                                    rules: [
                                                      _vm.fieldCharLimit(
                                                        "reference",
                                                        _vm.getCurShippingService(
                                                          props.item
                                                            .shippingService
                                                        ).referenceLength || 40
                                                      )
                                                    ],
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      props.item.referenceValue,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        props.item,
                                                        "referenceValue",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "props.item.referenceValue"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form-" + props.item.orderId + "-3",
                                  attrs: { "lazy-validation": "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("senderName"),
                                              rules: [
                                                _vm.fieldIsRequired(
                                                  "sender name"
                                                ),
                                                _vm.fieldCharLimit(
                                                  "Sender name",
                                                  35
                                                )
                                              ],
                                              "prepend-icon": "person",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: props.item.senderName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "senderName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.senderName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("companyName"),
                                              "prepend-icon": "business",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: props.item.fromCompanyName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "fromCompanyName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.fromCompanyName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                lazy: "",
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "full-width": "",
                                                "min-width": "290px"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(data) {
                                                      return [
                                                        _c(
                                                          "v-text-field",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                value:
                                                                  props.item
                                                                    .shipDate,
                                                                label: _vm.$t(
                                                                  "shipDate"
                                                                ),
                                                                "prepend-icon":
                                                                  "event",
                                                                readonly: "",
                                                                "hide-details":
                                                                  ""
                                                              }
                                                            },
                                                            data.on
                                                          )
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: props.item.shipDateMenu,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "shipDateMenu",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item.shipDateMenu"
                                              }
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("v-date-picker", {
                                                on: {
                                                  input: function($event) {
                                                    props.item.shipDateMenu = false
                                                  }
                                                },
                                                model: {
                                                  value: props.item.shipDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.item,
                                                      "shipDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "props.item.shipDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "hide-details": "",
                                              "prepend-icon": "business_center",
                                              label: _vm.$t("declaredValue"),
                                              disabled: !props.item
                                                .enableInsured,
                                              rules: [
                                                _vm.fieldIsRequired("value"),
                                                _vm.fieldIsNoLessThanZero(
                                                  "value"
                                                )
                                              ]
                                            },
                                            model: {
                                              value: props.item.insuredValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "insuredValue",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "props.item.insuredValue"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              "prepend-icon": "bookmarks",
                                              label: _vm.$t("signatureService"),
                                              items: _vm.getLabelServiceSettingByCarrierAndServiceTypeValue(
                                                props.item.carrier,
                                                props.item.shippingService
                                              ).signatureOptions,
                                              "item-text": "text",
                                              "menu-props": {
                                                returnValue: "value"
                                              },
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: props.item.signature,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "signature",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.signature"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("memo"),
                                              value: props.item.replacedMemo,
                                              "hide-details": "",
                                              rules: [
                                                _vm.fieldCharLimit(
                                                  "Memo",
                                                  _vm.getCurShippingService(
                                                    props.item.shippingService
                                                  ).memoLength || 40
                                                )
                                              ],
                                              "prepend-icon": "note"
                                            },
                                            on: {
                                              input: function(value) {
                                                return (props.item.memo = value)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t("note"),
                                              "prepend-icon": "note"
                                            },
                                            model: {
                                              value: props.item.buyerNote,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "buyerNote",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.buyerNote"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _vm.isLoadingRates[props.item.orderId]
                                ? _c(
                                    "v-layout",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : !_vm.rates[props.item.orderId] ||
                                  !Object.keys(_vm.rates[props.item.orderId])
                                    .length
                                ? _c(
                                    "v-layout",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _vm._v(
                                        "\n              $ ----\n            "
                                      )
                                    ]
                                  )
                                : _c(
                                    "v-layout",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(tooltip) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      _vm._g({}, tooltip.on),
                                                      [
                                                        _vm._v(
                                                          "$" +
                                                            _vm._s(
                                                              _vm.rates[
                                                                props.item
                                                                  .orderId
                                                              ].total
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(_vm.$t("baseCharge")) + ":"
                                            )
                                          ]),
                                          _vm._v(
                                            " $" +
                                              _vm._s(
                                                _vm.rates[props.item.orderId]
                                                  .rate
                                              ) +
                                              "\n                "
                                          ),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(_vm.$t("surcharge")) + ":"
                                            )
                                          ]),
                                          _vm._v(
                                            " $" +
                                              _vm._s(
                                                _vm.rates[props.item.orderId]
                                                  .surcharge
                                              ) +
                                              "\n                "
                                          ),
                                          _vm.rates[props.item.orderId]
                                            .isResidential
                                            ? _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("residential"))
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        disabled:
                                          _vm.isLoadingRates[
                                            props.item.orderId
                                          ],
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.getRate(props.item.orderId)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("getRate")))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(tooltip) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "order-btn",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isLoadingRates[
                                                            props.item.orderId
                                                          ],
                                                        color: "primary",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.getRate(
                                                            props.item.orderId,
                                                            true
                                                          )
                                                        }
                                                      }
                                                    },
                                                    tooltip.on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("autoGetRate")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(props.item.carriers.join(", "))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "order-btn",
                                      attrs: {
                                        color: "primary",
                                        icon: "",
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.editAutoGetRateCarriers(
                                            props.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              props.item.moreRates.length
                                ? _c(
                                    "v-layout",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-width": 200,
                                            "offset-x": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "order-btn",
                                                          attrs: {
                                                            color: "primary",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.showMoreRates(
                                                                props.item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "moreRates"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: props.item.showMoreRates,
                                            callback: function($$v) {
                                              _vm.$set(
                                                props.item,
                                                "showMoreRates",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "props.item.showMoreRates"
                                          }
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c("v-card-text", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      height: "300px",
                                                      overflow: "auto"
                                                    }
                                                  },
                                                  [
                                                    _c("v-data-table", {
                                                      attrs: {
                                                        headers: [
                                                          {
                                                            text: _vm.$t(
                                                              "service"
                                                            ),
                                                            align: "left",
                                                            sortable: false,
                                                            value: "serviceType"
                                                          },
                                                          {
                                                            text:
                                                              _vm.$t(
                                                                "baseCharge"
                                                              ) + " ($)",
                                                            align: "left",
                                                            sortable: false,
                                                            value: "rate"
                                                          },
                                                          {
                                                            text:
                                                              _vm.$t(
                                                                "surcharge"
                                                              ) + " ($)",
                                                            align: "left",
                                                            sortable: false,
                                                            value: "surcharge"
                                                          },
                                                          {
                                                            text:
                                                              _vm.$t("total") +
                                                              " ($)",
                                                            align: "left",
                                                            sortable: false,
                                                            value: "total"
                                                          },
                                                          {
                                                            text: _vm.$t(
                                                              "estDelivery"
                                                            ),
                                                            align: "left",
                                                            sortable: false,
                                                            value: ""
                                                          }
                                                        ],
                                                        items:
                                                          props.item.moreRates,
                                                        "item-key":
                                                          "serviceType",
                                                        "hide-actions": ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "items",
                                                            fn: function(ref) {
                                                              var item =
                                                                ref.item
                                                              return [
                                                                _c("td", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        linkify:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.switchShippingService(
                                                                            _vm
                                                                              .orders[
                                                                              props
                                                                                .item
                                                                                .orderId
                                                                            ],
                                                                            item
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.serviceDescription ||
                                                                            item.serviceType
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.rate
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.surcharge ||
                                                                        "N/A"
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.totalAmount
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.formatEstDeliveryDate(
                                                                          item.estimatedDelivery
                                                                        )
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ])
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-actions",
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.item.showMoreRates = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("close"))
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        flat: "",
                                        dark: "",
                                        color: "primary",
                                        disabled:
                                          _vm.isLoading || _vm.isBatchLoading
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removeOrder(props.item)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "position-x": _vm.x,
                      "position-y": _vm.y,
                      absolute: "",
                      "offset-y": "",
                      "close-on-content-click": false
                    },
                    model: {
                      value: _vm.templateMenu,
                      callback: function($$v) {
                        _vm.templateMenu = $$v
                      },
                      expression: "templateMenu"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-container",
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-autocomplete", {
                                  staticStyle: { "margin-bottom": "0" },
                                  attrs: {
                                    label: _vm.$t("instructionTemplate"),
                                    items: _vm.instructions,
                                    "item-text": "name",
                                    "return-object": "",
                                    clearable: ""
                                  },
                                  on: { input: _vm.changeInstruction },
                                  model: {
                                    value: _vm.instructionTemplate,
                                    callback: function($$v) {
                                      _vm.instructionTemplate = $$v
                                    },
                                    expression: "instructionTemplate"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _c("v-textarea", {
                                  staticClass: "thinBox",
                                  attrs: {
                                    label: _vm.$t("shipmentInstruction"),
                                    outline: "",
                                    rows: "8"
                                  },
                                  model: {
                                    value: _vm.instructionInEdit,
                                    callback: function($$v) {
                                      _vm.instructionInEdit = $$v
                                    },
                                    expression: "instructionInEdit"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", flat: "" },
                                on: {
                                  click: function() {
                                    _vm.templateMenu = false
                                    _vm.instructionInEdit = ""
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", flat: "" },
                                on: {
                                  click: function() {
                                    _vm.orderInEdit.instruction =
                                      _vm.instructionInEdit
                                    _vm.templateMenu = false
                                    _vm.instructionInEdit = ""
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("save")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "position-x": _vm.x,
                      "position-y": _vm.y,
                      absolute: "",
                      "offset-y": "",
                      "close-on-content-click": false
                    },
                    model: {
                      value: _vm.addressMenu,
                      callback: function($$v) {
                        _vm.addressMenu = $$v
                      },
                      expression: "addressMenu"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-form",
                              {
                                ref: "form-address",
                                attrs: { "lazy-validation": "" }
                              },
                              [
                                _vm.addressInEditType === "to"
                                  ? _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { md5: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("recipientName"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Recipient name"
                                                  ),
                                                  _vm.fieldCharLimit(
                                                    "Recipient name",
                                                    35
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.addressInEdit.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.addressInEdit,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "addressInEdit.name"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md5: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t("companyName"),
                                                "hide-details": ""
                                              },
                                              model: {
                                                value:
                                                  _vm.addressInEdit
                                                    .toCompanyName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.addressInEdit,
                                                    "toCompanyName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "addressInEdit.toCompanyName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            readonly: _vm.isReadonly,
                                            rules: [
                                              _vm.fieldIsRequired("Address1"),
                                              _vm.fieldCharLimit("address1", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.addressInEdit.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "address1",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.addressInEdit.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "address2",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("city"),
                                            readonly: _vm.isReadonly,
                                            rules: [_vm.fieldIsRequired("City")]
                                          },
                                          model: {
                                            value: _vm.addressInEdit.city,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.city"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.getStates(
                                              _vm.orderInEdit
                                                ? _vm.orderInEdit
                                                    .shippingService
                                                : null
                                            ),
                                            label: _vm.$t("state"),
                                            readonly: _vm.isReadonly,
                                            rules: [
                                              _vm.fieldIsRequired("State")
                                            ]
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "item",
                                              fn: function(data) {
                                                return [
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            attrs: {
                                                              id: data.item
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  data.item
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.addressInEdit.state,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "state",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.state"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("zipCode"),
                                            readonly: _vm.isReadonly,
                                            rules: [
                                              _vm.fieldIsRequired("Zip code")
                                            ]
                                          },
                                          model: {
                                            value: _vm.addressInEdit.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "zipCode",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "justify-space-between": "",
                                      "align-baseline": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      _vm._b(
                                        {},
                                        "v-flex",
                                        {
                                          md3:
                                            (_vm.addressInEditType === "from" &&
                                              _vm.orderInEdit
                                                .isSupportFromExt) ||
                                            (_vm.addressInEditType === "to" &&
                                              _vm.orderInEdit.isSupportToExt),
                                          md5:
                                            (_vm.addressInEditType === "from" &&
                                              !_vm.orderInEdit
                                                .isSupportFromExt) ||
                                            (_vm.addressInEditType === "to" &&
                                              !_vm.orderInEdit.isSupportToExt)
                                        },
                                        false
                                      ),
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("phone"),
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.addressInEdit.phone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.addressInEdit,
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression: "addressInEdit.phone"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    (_vm.addressInEditType === "from" &&
                                      _vm.orderInEdit.isSupportFromExt) ||
                                    (_vm.addressInEditType === "to" &&
                                      _vm.orderInEdit.isSupportToExt)
                                      ? _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t("extension"),
                                                rules: [
                                                  _vm.fieldCharLimit(
                                                    "extension",
                                                    6
                                                  )
                                                ],
                                                "hide-details": ""
                                              },
                                              model: {
                                                value:
                                                  _vm.addressInEdit.extension,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.addressInEdit,
                                                    "extension",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "addressInEdit.extension"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md: "", lg3: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              flat: "",
                                              color: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.goToGoogleMapLink.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("location_on")
                                            ]),
                                            _vm._v(_vm._s(_vm.$t("googleMap")))
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", flat: "" },
                                on: {
                                  click: function($event) {
                                    _vm.addressMenu = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", flat: "" },
                                on: {
                                  click: function() {
                                    return _vm.addressInEditType === "from"
                                      ? _vm.saveAddressFrom()
                                      : _vm.saveAddressTo()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("save")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-content-click": false,
                      "position-x": _vm.x,
                      "position-y": _vm.y,
                      "nudge-right": 40,
                      lazy: "",
                      transition: "scale-transition",
                      "offset-y": "",
                      "full-width": "",
                      "min-width": "290px"
                    },
                    model: {
                      value: _vm.shipDateMenu,
                      callback: function($$v) {
                        _vm.shipDateMenu = $$v
                      },
                      expression: "shipDateMenu"
                    }
                  },
                  [
                    _c("v-date-picker", {
                      on: {
                        input: function($event) {
                          _vm.shipDateMenu = false
                        }
                      },
                      model: {
                        value: _vm.orderInEdit.shipDate,
                        callback: function($$v) {
                          _vm.$set(_vm.orderInEdit, "shipDate", $$v)
                        },
                        expression: "orderInEdit.shipDate"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "control1",
            fn: function(ref) {
              var loaderButtonError = ref.loaderButtonError
              return [
                _c("LoaderButton", {
                  staticClass: "ml-3",
                  attrs: {
                    buttonText: _vm.$t("submitOrder"),
                    promiseAwait: _vm.batchOrder,
                    loading: _vm.isBatchLoading,
                    disabled: _vm.isLoading
                  },
                  on: { loaderButtonError: loaderButtonError },
                  model: {
                    value: _vm.isBatchLoading,
                    callback: function($$v) {
                      _vm.isBatchLoading = $$v
                    },
                    expression: "isBatchLoading"
                  }
                })
              ]
            }
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _vm.addInventoriesDialog
        ? _c("AddInventories", {
            attrs: {
              title: _vm.$t("selectProduct"),
              addedDistributionSet: _vm.addedDistributionSet,
              editMode: true,
              skus: _vm.skus,
              allDistribution: _vm.allDistribution
            },
            on: {
              showAddProductDialog: function(item) {
                return _vm.showAddProductDialog(item)
              },
              deleteDistribution: function(item) {
                return _vm.deleteProduct(item)
              },
              addDistribution: function(item) {
                return _vm.addProduct(item)
              }
            },
            model: {
              value: _vm.addInventoriesDialog,
              callback: function($$v) {
                _vm.addInventoriesDialog = $$v
              },
              expression: "addInventoriesDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createTemplateDialog
        ? _c("LabelTemplatePopup", {
            attrs: { initTemplate: _vm.templateInEdit },
            on: { submitted: _vm.onCreateTemplate },
            model: {
              value: _vm.createTemplateDialog,
              callback: function($$v) {
                _vm.createTemplateDialog = $$v
              },
              expression: "createTemplateDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dangerousGoodsDialog.show
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("dangerousGoods"),
              rightMethod: _vm.onSubmittedDangerousGoods,
              rightButtonText: _vm.$t("ok"),
              large: ""
            },
            on: {
              popupClose: function($event) {
                _vm.dangerousGoodsDialog.show = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("HazardousCommodities", {
                        ref: "HazardousCommodities",
                        attrs: {
                          dangerousGoods:
                            _vm.dangerousGoodsDialog.data.dangerousGoods,
                          offerorName:
                            _vm.dangerousGoodsDialog.data.offerorName,
                          emergencyContactNumber:
                            _vm.dangerousGoodsDialog.data
                              .emergencyContactNumber,
                          dryIceWeight:
                            _vm.dangerousGoodsDialog.data.dryIceDetail.weight,
                          dryIceUnit:
                            _vm.dangerousGoodsDialog.data.dryIceDetail.unit
                        },
                        on: {
                          "update:dangerousGoods": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "dangerousGoods",
                              $event
                            )
                          },
                          "update:dangerous-goods": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "dangerousGoods",
                              $event
                            )
                          },
                          "update:offerorName": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "offerorName",
                              $event
                            )
                          },
                          "update:offeror-name": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "offerorName",
                              $event
                            )
                          },
                          "update:emergencyContactNumber": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "emergencyContactNumber",
                              $event
                            )
                          },
                          "update:emergency-contact-number": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "emergencyContactNumber",
                              $event
                            )
                          },
                          "update:dryIceWeight": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data.dryIceDetail,
                              "weight",
                              $event
                            )
                          },
                          "update:dry-ice-weight": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data.dryIceDetail,
                              "weight",
                              $event
                            )
                          },
                          "update:dryIceUnit": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data.dryIceDetail,
                              "unit",
                              $event
                            )
                          },
                          "update:dry-ice-unit": function($event) {
                            return _vm.$set(
                              _vm.dangerousGoodsDialog.data.dryIceDetail,
                              "unit",
                              $event
                            )
                          }
                        },
                        model: {
                          value: _vm.dangerousGoodsDialog.data.hazMatsInfo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dangerousGoodsDialog.data,
                              "hazMatsInfo",
                              $$v
                            )
                          },
                          expression: "dangerousGoodsDialog.data.hazMatsInfo"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4214565446
            ),
            model: {
              value: _vm.dangerousGoodsDialog.show,
              callback: function($$v) {
                _vm.$set(_vm.dangerousGoodsDialog, "show", $$v)
              },
              expression: "dangerousGoodsDialog.show"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("carrier"),
          rightMethod: _vm.onSubmittedEditCarriers,
          rightButtonText: _vm.$t("ok"),
          small: ""
        },
        on: {
          popupClose: function($event) {
            _vm.carriersDialog.show = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("v-select", {
                  attrs: { items: _vm.allCarriers, multiple: "" },
                  model: {
                    value: _vm.carriersDialog.carriers,
                    callback: function($$v) {
                      _vm.$set(_vm.carriersDialog, "carriers", $$v)
                    },
                    expression: "carriersDialog.carriers"
                  }
                })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.carriersDialog.show,
          callback: function($$v) {
            _vm.$set(_vm.carriersDialog, "show", $$v)
          },
          expression: "carriersDialog.show"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddc44b84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddc44b84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuyLabelPopup.vue
// module id = null
// module chunks = 